<template>
  <div class="quotationIntegrationHistory">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.onlineOrder.cargoCategorySn"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.onlineOrder.cargoCategorySn }}：{{ item.CargoCategory }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.firstWeightSn }}：{{ item.FirstWeightStr }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.firstWeightPrice }}：{{ item.FirstWeightPriceStr }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.continueWeightSn }}：{{ item.ContinuousWeightStr }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.continuePrice }}：{{ item.ContinuousWeightPriceStr }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.pointsObtainConditions }}：{{
            item.PointsObtainConditionsStr
          }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.pointsIncome }}：{{ item.PointsIncome }}
        </div>
        <div class="list-item">
          {{ $t.onlineOrder.reducedPointsIncome }}：{{ item.ReducedPointsIncome }}
        </div>
        <div class="list-item">{{ $t.onlineOrder.ruleDate }}：{{ item.DeleteTime }}</div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { List, Row, Col, Button, Form, Field, Search } from "vant";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Button).use(Form).use(Field).use(Search);

export default {
  name: "quotationIntegrationHistory",
  data() {
    return {
      FPId: "",
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
    };
  },
  created() {
    const { FPId } = this.$route.query;
    this.FPId = FPId;
  },
  methods: {
    onSearch() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        CargoCategory: this.searchText,
        FPId: this.FPId,
      };
      this.$api.onlineOrderManagement
        .getPointsRulesHistoryListByPage(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.quotationIntegrationHistory {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        .van-search__action {
          width: 15%;
        }
        .van-search__content {
          padding: 0px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
      }
    }
  }
  .list {
    .list-container {
      margin-top: 10px;
      font-size: 12px;
      color: #333;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      padding: 10px;
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
